require('../vendors/cycle/cycle')(require('jquery'));

var ClientSlider = function ClientSlider($element, options) {
	$element.cycle({
		pager: options.pager,
		slides: options.slides
	});
}

module.exports = ClientSlider;